import {
  SET_SELECTED_CARD_ITEM,
  SET_SELECTED_CARDS,
  FLUSH_FORM,
  SET_FORM,
} from './constants'

const initialState = {
  form_submitted_once: false,
  ref: '',
  title: '',
  operator_name: '',
  ends_at: new Date(),
  status: 'pending',
  active: true,
  message: '',
  audits: [],
  selected_card_item: null,
  selected_cards: [],
  updated: true,
}

const create = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_CARD_ITEM:
      return {
        ...state,
        selected_card_item: action.payload,
      }
    case SET_SELECTED_CARDS:
      return {
        ...state,
        selected_cards: action.payload,
      }
    case FLUSH_FORM:
      return initialState
    case SET_FORM:
      return {
        ...state,
        [action.element]: action.value,
        updated: false,
      }
    default:
      return state
  }
}

export default create
